import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/shop/pageMoney', data, {
    trim: true
  })
}
export function exportExcel (data) {
  return request.post('/business/shop/exportExcelMoney', data, {
    trim: true,
    download: true
  })
}
